import { Chapter, FadeIn } from "./Reveal";
import { CAPABILITIES, IMAGES } from "../data/site";

const CapabilityCard = ({ cap, index }) => (
    <FadeIn
        delay={index * 0.08}
        className={`group relative overflow-hidden border border-line bg-coal/50 transition-colors duration-300 hover:border-ember/60 ${cap.span}`}
    >
        {cap.image && (
            <div className="absolute inset-0">
                <img
                    src={IMAGES[cap.image]}
                    alt={cap.title}
                    className="h-full w-full object-cover opacity-25 grayscale transition-all duration-700 group-hover:opacity-40 group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
            </div>
        )}
        <div className="relative flex h-full flex-col justify-between gap-10 p-8 md:p-10">
            <div className="flex items-start justify-between">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ember">
                    C.{String(index + 1).padStart(2, "0")}
                </span>
                <span className="h-8 w-px bg-line transition-colors group-hover:bg-ember" />
            </div>
            <div>
                <h3 className="font-display text-3xl uppercase tracking-tight text-zinc-100 md:text-4xl">
                    {cap.title}
                </h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-zinc-400">
                    {cap.desc}
                </p>
                {cap.chain ? (
                    <div
                        data-testid="process-chain"
                        className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2"
                    >
                        {cap.stats.map((s, i) => (
                            <span key={s} className="flex items-center gap-3">
                                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-300 md:text-xs">
                                    {s}
                                </span>
                                {i < cap.stats.length - 1 && (
                                    <span className="font-mono text-xs text-ember">→</span>
                                )}
                            </span>
                        ))}
                    </div>
                ) : (
                    <ul className="mt-8 space-y-2">
                        {cap.stats.map((s) => (
                            <li
                                key={s}
                                className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 md:text-xs"
                            >
                                <span className="h-px w-4 bg-ember" />
                                {s}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    </FadeIn>
);

export const Capabilities = () => (
    <section
        id="capabilities"
        data-testid="capabilities-section"
        className="py-28 md:py-40"
    >
        <div className="mx-auto max-w-screen-2xl px-6 md:px-12">
            <Chapter number="02" label="Capabilities" />
            <FadeIn>
                <h2 className="mb-14 max-w-4xl font-display text-4xl uppercase leading-[0.95] tracking-tight text-zinc-100 md:mb-20 md:text-6xl">
                    Cast. Forge. <span className="text-outline">Machine.</span> Deliver.
                </h2>
            </FadeIn>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-12">
                {CAPABILITIES.map((cap, i) => (
                    <CapabilityCard key={cap.id} cap={cap} index={i} />
                ))}
            </div>
        </div>
    </section>
);
